import { ACTIONS } from '_redux/actions';

const initialState = {
  content: {
    cultureItems: [],
  },
  contentLoading: true,
};

export default function cultures(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.CULTURES.FETCH_CULTURES:
      return {
        ...state,
        contentLoading: true,
      };

    case ACTIONS.CULTURES.FETCH_CULTURES_SUCCESS:
      return {
        ...state,
        content: {
          ...action.payload.data,
        },
        contentLoading: false,
      };

    default:
      return state;
  }
}
